import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem("pp_token");
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    const { token, ...u } = r.data;
    setUser(u);
    return u;
  };

  const logout = async () => {
    setUser(null);
    if (window.caches) caches.delete("connectick-api").catch(() => {});
    try { await api.post("/auth/logout"); } catch { /* sessão já expirada */ }
  };

  return <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
